import { render, staticRenderFns } from "./realtime.vue?vue&type=template&id=3b891a24&scoped=true&"
import script from "./realtime.vue?vue&type=script&lang=js&"
export * from "./realtime.vue?vue&type=script&lang=js&"
import style0 from "./realtime.vue?vue&type=style&index=0&id=3b891a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b891a24",
  null
  
)

export default component.exports